<template>
  <fragment>
    <p class="text-muted text-center" v-if="!entity || entity.length==0">
      <i class="feather icon-search display-4 d-block m-3"></i>
       - Nessun ordine trovato -
    </p>
    <div class="row" v-if="entity && entity.length>0">
      <div class="col-12">
        <table class="table w-100">
          <thead>
            <tr>
<th>Testata</th>
<th>Data prima pubblicazione</th>
<th>Data ultima pubblicazione</th>
<th>Fatturato</th>
<th>Incassato</th>
<th>A Scadere</th>
<th>Scaduto</th>
<th>Pubblicato</th>
<th>Da Pubblicare</th>

            </tr>
            </thead>
              <tbody>
 <tr  v-for="item in entity" v-bind:key="item.oneOrderId">
<td>{{item.name}}</td>
<td>{{item.firstPublishDate | formatDate}}</td>
<td>{{item.lastPublishDate | formatDate}}</td>
<td>{{item.amount | currency}}</td>
<td>{{item.cashed | currency}}</td>
<td>{{item.toExpire | currency}}</td>
<td>{{item.expired | currency}}</td>
<td>{{item.published | currency}}</td>
<td>{{item.toPublish | currency}}</td>

            </tr>

              </tbody>
          </table>
      </div>
    </div>
      
  </fragment>
</template>
<script>
import axios from "axios";
export default {
  name: "oneInformation",

  props: {
    readOnly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    value: {
      type: String,
      required: true,
    },
  },
  components: {},
  data() {
    return {
      entity: null,
     
      descriptions:[]
    };
  },
  methods: {
    getDescription(code) {
      for(var i=0; i< this.descriptions.length; i++){
        if(this.descriptions[i].code == code)
        return  this.descriptions[i].value

      }
     return code;
    },
  },

  beforeMount() {
    /*   var me = this;
            
           
*/
    let me = this;
   
 axios.get(`oneorder/${me.value}`).then((response) => {
        me.entity = response.data;
      });
 
  },
};
</script>
